import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphName, GraphType } from '../constants/Constants';
import { isElementInFullscreen } from '../utils/utils';
import Graphic from './Graphic';

/**
 *  文字
 *  使用fabric.IText 需求没有那么繁重，所以使用简单实现
 *  如果未来的某天需求变更， 则使用fabric.TextBox
 *
 * @export
 * @class CanvasText
 * @extends {Graphic}
 */
export default class CanvasText extends Graphic {
  constructor(app) {
    super(app);
    this.e = {
      [CanvasEventType.MouseUp]: this._mouseUp.bind(this),
      [CanvasEventType.TextChanged]: this._textChanged.bind(this)
    };
  }

  get option() {
    return this._option;
  }

  set option(val) {
    let fontSize = val['strokeWidth'] || val['fontSize'] || 14;
    val['strokeWidth'] = 0;
    val['fill'] = val['stroke'];
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    this._option.fontSize = fontSize;
  }

  get defaultOption() {
    let opt = new ToolOption();
    opt.fill = '#000000';
    opt.strokeWidth = 0;
    opt.placeholder = '请输入文本';
    opt.fontSize = 14;
    opt.gtype = GraphType.TEXT;
    opt.isRaw = true;
    return opt;
  }

  addEvents() {
    super.addEvents();

    this.root.on(CanvasEventType.MouseUp, this.e[CanvasEventType.MouseUp]);
    this.root.on(CanvasEventType.TextChanged, this.e[CanvasEventType.TextChanged]);
    this.root.on(CanvasEventType.Add, this.e[CanvasEventType.Add]);
  }

  removeEvents() {
    this.root.off(CanvasEventType.MouseUp, this.e[CanvasEventType.MouseUp]);
    this.root.off(CanvasEventType.TextChanged, this.e[CanvasEventType.TextChanged]);
    this.root.off(CanvasEventType.Add, this.e[CanvasEventType.Add]);
    this.removeUnmodifiedItem();
  }

  _mouseUp(o) {
    let target = o.target;

    if (target && target['gtype'] === 6) {
      this.removeUnmodifiedItem(target);
      return;
    }

    // 移除未修改过的item
    this.removeUnmodifiedItem();

    let sp = this.root.getPointer(o.e);
    let position = {};
    position.left = sp.x;
    position.top = sp.y;
    Object.assign(this.option, position);
    let text = new fabric[GraphName.TEXT](isElementInFullscreen() ? this.option.placeholder : '', this.option);
    text['padding'] = 6; // 设置选中区域边框距离， 太近了的话字号小，容易点错
    this.root.add(text);
    setTimeout(() => {
      this.root.setActiveObject(text);
      text.enterEditing();
      text.hiddenTextarea.focus();
    });
  }

  _textChanged(e) {
    let textObj = e.target;
    if (!textObj) {
      return;
    }
    textObj.styles = {}; // fix: 修复复制其它编辑的文本粘贴到当前输入框带样式的问题
    if (textObj.text) {
      textObj._updateTextarea();
    }
    textObj.setCoords();
    this.stage.renderNow();
  }

  removeUnmodifiedItem(escapeItem = null) {
    if (!this.root) {
      return;
    }

    let selectionStart = -1;
    let selectionEnd = -1;
    if (escapeItem) {
      selectionStart = escapeItem.selectionStart;
      selectionEnd = escapeItem.selectionEnd;
    }
    this.root.forEachObject(obj => {
      if (obj.hasOwnProperty('gtype') && obj['gtype'] === 6) {
        if (obj.isEditing) {
          obj.exitEditing(); // 如果是编辑状态则退出编辑
        }

        if (obj.uuid == escapeItem?.uuid) {
          if (
            selectionStart > -1 &&
            selectionEnd > selectionStart &&
            (obj.selectionStart !== selectionStart || obj.selectionEnd !== selectionEnd)
          ) {
            // 处理仍然保持文本的选中区域
            obj.selectionStart = selectionStart;
            obj.selectionEnd = selectionEnd;
            if (obj.selectionColor) {
              delete obj.selectionColor;
            }
          }
        }
      }
      // 是文本类型且文本和占位文本相同的情况下，认为是未做过修改的
      if (
        obj.hasOwnProperty('gtype') &&
        obj['gtype'] === 6 &&
        (obj['text'] === '' || obj['text'] === obj['placeholder'] || obj['text'] === this.option.placeholder) &&
        obj !== escapeItem
      ) {
        this.root.remove(obj);
      }
    });
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.text = target.text;
    obj.fill = target.fill;
    obj.fontSize = target.fontSize;
    obj.gtype = GraphType.TEXT;
    return obj;
  }

  static toModifyData(target) {
    let obj = Graphic.toModifyData(target);
    obj.text = target.text;
    obj.fill = target.fill;
    obj.fontSize = target.fontSize;
    return obj;
  }
}

const defaultOption = {
  placeholder: '请输入内容',
  fill: '#FFFFFF',
  textAlign: 'left',
  strokeWidth: 0,
  stroke: '#FFFFFF',
  fontSize: 14,
  width: 200
};
